import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.validate.js";
import "LIBS/jquery.validate.unobtrusive.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.WriteReviewModal
*
* Encapsulates the functionality of a modal dialog that contains product information.
**/
HSN.WriteReviewModal = (function (parent) {
    __extends(WriteReviewModal, parent);

    /**
    * new HSN.WriteReviewModal()
    **/
    function WriteReviewModal() {
        this.name = 'HSN.WriteReviewModal';
        this.data;

        return WriteReviewModal.__super__.constructor.call(this);
    }

    /**
    * HSN.WriteReviewModal#Show(productId) -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    WriteReviewModal.prototype._show = function (ajaxData, url) {
        var scope = this;
        this.ajaxData = ajaxData || this.ajaxData;

        let writeReviewPromise = import(/* webpackChunkName: "WriteReview" */ 'HSNDIR/Template/WriteReview.js');

        let ajax = $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: this.ajaxData,
        });

        Promise.all([ajax, writeReviewPromise]).then(([data, WriteReview]) => {
                scope.Root.removeClass('loading');
                scope.DisplayModal(data, 0);                
            })
            .catch(() => {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            });
    };

    /**
    * Submit for review modal form, use ajax to retrieve response, and update modal content
    **/
    WriteReviewModal.prototype.SubmitReviewForm = function () {
        var scope = this;
        var reviewForm = $('form', scope.Root);

        //manually run client validation since we arent running submit operation
        if (!reviewForm.valid())
            return;

        $.ajax({
            type: 'POST',
            url: '/writereview?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: reviewForm.serialize(),
        })
            .done(function (data) {
                if (data) {
                    if (!$(data).find('.validation-summary-errors').data('valmsgSummary')) {
                    }
                }

                scope.DisplayModal(data, 0);
            })
            .fail(function () {
                alert('error submitting review');
            });
    };

    var onContentKeydown = {};

    WriteReviewModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time,
            function () {
                //needed for unobtrusive client side validation for ajax loaded form
                $.validator.unobtrusive.parse($('form', scope.Root));
                scope.Center();
                scope.Content.animate(
                    { opacity: 1 },
                    function () {
                        scope.Close.focus();                        

                        if (typeof onContentKeydown !== 'function') {
                            onContentKeydown = function (e) {
                                if (e.key === 'Tab') {
                                    e.preventDefault();

                                    scope.Close.focus();
                                }
                            }

                            scope.Content.on('keydown', onContentKeydown);
                        }
                    }
                );
            },
            function () {
                //scope.Center();
            });

    };

    return WriteReviewModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/WriteReviewModal.js